import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'math-lower', 'MathLower', [["path",{"d":"M19 18l-14 -6l14 -6"}]]);